import { LotRecommendationType } from './trackLotRecommendationClicked.analytics';

export const getRecommendationTypeFromTitle = (title: string): LotRecommendationType | null => {
    const lowerTitle = title.toLowerCase();

    if (lowerTitle.includes('trending')) {
        return LotRecommendationType.TrendingItems;
    }
    if (lowerTitle.includes('recently viewed')) {
        return LotRecommendationType.RecentlyViewed;
    }
    if (lowerTitle.includes('favorites')) {
        return LotRecommendationType.RecommendedFromSaves;
    }
    if (lowerTitle.includes('recommended')) {
        return LotRecommendationType.RecommendedItems;
    }
    if (lowerTitle.includes('related')) {
        return LotRecommendationType.RelatedCategory;
    }
    if (lowerTitle.includes('more items')) {
        return LotRecommendationType.MoreItems;
    }
    if (lowerTitle.includes('similar upcoming')) {
        return LotRecommendationType.YouMayAlsoLike;
    }
    if (lowerTitle.includes('similar')) {
        return LotRecommendationType.SimilarSaleHistory;
    }
    if (lowerTitle.includes('you may also like')) {
        return LotRecommendationType.YouMayAlsoLike;
    }

    return null;
};
